export class Question {
  QuestionId: number;
  TypeId: number;
  TopicId: number;
  SubTopicId: number;
  TopicName: string;
  SubTopicName: string;
  Content: string;
  Notes: string;
  CreateDate: string;
  Active: boolean;
}
